// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App'
//import router from './router/index'

import "@babel/polyfill";

import 'whatwg-fetch';


// todo
// cssVars()

import Tabs from "vue-material-tabs";
Vue.use(Tabs);

import Loader from "@/components/Loader"
Vue.component('Loader',Loader)

import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy, {
  defaultProps: {
    allowHTML: true
  }
});
Vue.component("tippy", TippyComponent);

import VueRouter from 'vue-router'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import { Datetime } from 'vue-datetime'

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'


//import App from './App'
import router from './router/approuter'
import config from './aws-exports'
import { store } from './store'
import VueNativeSock from 'vue-native-websocket'
import i18n from './i18n'

import axios from 'axios'
import VueAxios from 'vue-axios'

import moment from 'moment'
Vue.prototype.moment = moment
axios.defaults.baseURL = process.env.VUE_APP_API_REST_URL;

Amplify.configure(config)
Vue.use(Datetime)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(VueNativeSock, 'ws://localhost:9090', { 
  store: store, 
  format: 'json',
  reconnection: false,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  connectManually: true 
})

Vue.use(VueAxios, axios)

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.config.performance = true
//Vue.use(CoreuiVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})
